export const enGb = {
  accountName: "Account name",
  accountNumber: "Account number",
  backToAllMandates: "Back to all mandates",
  beneficiary: "Beneficiary",
  bsb: "BSB",
  clickToCopyNotificationId: "Click to copy Notification ID",
  clientError: "Client Error",
  completed: "Completed",
  currency: "Currency",
  date: "Date (UTC)",
  delivered: "Delivered",
  description: "Description",
  email: "Email",
  failed: "Failed",
  givenMandateCouldNotBeFound:
    "This mandate could not be found. Make sure you are on the correct mode (production/sandbox).",
  httpCode: "HTTP Code",
  leadingToFailure: "Leading to failure",
  legalName: "Legal name",
  mandate: "Mandate",
  mandateDetails: "Mandate details",
  mandateNotFound: "Mandate not found",
  mandates: "Mandates",
  maxPaymentCountPerPeriod: "Max payment count per period",
  maxTotalAmountPerPeriod: "Maximum total amount per period",
  name: "Name",
  networkError: "Network Error",
  noMandatePaymentsYet: "You don't have any payments yet",
  noRecords: "No records",
  noResults: "No Results",
  notAvailable: "Not available",
  notificationId: "Notification ID",
  notificationResponse: "Notification Response",
  notifications: "Notifications",
  notificationsX: "Notifications ({{count}})",
  notificationType: "Type",
  notReceived: "Not received",
  notSent: "Not Sent",
  payer: "Payer",
  payId: "PayID®",
  paymentGateway: "Payment Gateway",
  payments: "Payments",
  pending: "Pending",
  period: "Period",
  periodAdhoc: "Ad hoc",
  periodDay: "Daily",
  periodMonth: "Monthly",
  periodWeek: "Weekly",
  periodYear: "Yearly",
  received: "Received",
  redirect: "Redirect",
  response: "Response",
  retry: "Retry",
  serverError: "Server Error",
  singlePaymentLimitAmount: "Amount per payment",
  singlePaymentLimitMaxAmount: "Max amount per payment",
  status: "Status",
  statusGroupFailed: "Failed",
  statusGroupPending: "Pending",
  success: "Success",
  thereAreNoMandateNotifications:
    "There are no notifications for this mandate. If this doesn't seem right, please contact your implementation team.",
  timeoutError: "Timeout Error",
  tooManyRetries: "Too many retries",
  uniqueReference: "Unique reference",
  untilCancelled: "Until cancelled",
  validityFrom: "Valid from",
  validityTo: "Valid to",
  view: "View",
  voltCustomerId: "Volt customer ID",
  voltMandateId: "Volt mandate ID",
} as const;
